module.exports = __webpack_public_path__ + "img/24-1.ff901a6d.png";